import React, { useState, useEffect } from "react";
import { MapPin, Hash, FileCheck } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { getCities } from "../../apiCalls/city";
import { updateLeagalInfo } from "../../apiCalls/user";

const SaveLeagalInfo = ({ legalData, labId, isEditing, setIsEditing }) => {
  const dispatch     = useDispatch();
  const { cities }   = useSelector((state) => state.city);

  const [profileData, setProfileData] = useState({
    labAddress: "", city: "", state: "Delhi", pinCode: "", licenseNumber: "", registrationNumber: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit,   setIsSubmit]   = useState(false);

  useEffect(() => { getCities(dispatch); }, [dispatch]);
  useEffect(() => { if (legalData) setProfileData((p) => ({ ...p, ...legalData })); }, [legalData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((p) => ({ ...p, [name]: value }));
    if (formErrors[name]) setFormErrors((e) => ({ ...e, [name]: "" }));
  };

  const validate = (v) => {
    const err = {};
    if (!v.labAddress) err.labAddress = "Address is required";
    return err;
  };

  const handleSave = (e) => {
    e.preventDefault();
    const err = validate(profileData);
    setFormErrors(err);
    setIsSubmit(true);
  };

  const handleClick = async () => {
    const { labAddress, city, state, pinCode, licenseNumber, registrationNumber } = profileData;
    await updateLeagalInfo({ labAddress, city, state, pinCode, licenseNumber, registrationNumber }, labId);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) handleClick();
  }, [formErrors]);

  return (
    <div className="form-card h-100">
      <div className="form-card-header">
        <h5 className="form-card-title">
          <MapPin size={15} /> Address &amp; Legal Info
        </h5>
      </div>

      <div className="form-card-body">

        {/* Address */}
        <div className="field">
          <label className="field-label">
            <MapPin size={13} /> Address <span className="req">*</span>
          </label>
          <textarea
            name="labAddress"
            value={profileData.labAddress || ""}
            onChange={handleInputChange}
            disabled={!isEditing}
            rows={2}
            className={`field-textarea ${formErrors.labAddress ? "is-error" : ""}`}
            placeholder={isEditing ? "Enter full address" : "—"}
          />
          {formErrors.labAddress && <span className="field-error">{formErrors.labAddress}</span>}
        </div>

        {/* City + State row */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.875rem" }}>
          <div className="field">
            <label className="field-label"><MapPin size={13} /> City</label>
            <select
              name="city"
              value={profileData.city || ""}
              onChange={handleInputChange}
              disabled={!isEditing}
              className="field-select"
            >
              <option value="">Select city</option>
              {cities.map((c) => (
                <option key={c._id} value={c._id}>{c.cityName}</option>
              ))}
            </select>
          </div>
          <div className="field">
            <label className="field-label"><MapPin size={13} /> State</label>
            <input
              type="text"
              name="state"
              value={profileData.state || ""}
              onChange={handleInputChange}
              disabled={!isEditing}
              className="field-input"
              placeholder="State"
            />
          </div>
        </div>

        {/* Pin code */}
        <div className="field">
          <label className="field-label"><Hash size={13} /> PIN Code</label>
          <input
            type="text"
            name="pinCode"
            value={profileData.pinCode || ""}
            onChange={handleInputChange}
            disabled={!isEditing}
            className="field-input"
            placeholder={isEditing ? "Enter PIN code" : "—"}
          />
        </div>

        {/* License */}
        <div className="field">
          <label className="field-label"><FileCheck size={13} /> License Number</label>
          <input
            type="text"
            name="licenseNumber"
            value={profileData.licenseNumber || ""}
            onChange={handleInputChange}
            disabled={!isEditing}
            className="field-input"
            placeholder={isEditing ? "Enter license number" : "—"}
          />
        </div>

        {/* Registration */}
        <div className="field">
          <label className="field-label"><FileCheck size={13} /> Registration Number</label>
          <input
            type="text"
            name="registrationNumber"
            value={profileData.registrationNumber || ""}
            onChange={handleInputChange}
            disabled={!isEditing}
            className="field-input"
            placeholder={isEditing ? "Enter registration number" : "—"}
          />
        </div>

        {isEditing && (
          <button className="app-btn app-btn--primary" onClick={handleSave} style={{ marginTop: "0.5rem" }}>
            <MapPin size={14} /> Save Legal Info
          </button>
        )}
      </div>
    </div>
  );
};

export default SaveLeagalInfo;
